import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { fullDateFormat, priceFormat } from "util/commAction";

type IPayInf = {
  payInf: {
    resvAmt: number;
    payAmt: number;
    payStaCd: string;
    payStaNm: string;
    dscAmt: string; // 할인 금액
    sellAmt: string;
    cnlFeeAmt: string;
  };
};

export default function PayInf({ payInf }: IPayInf) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const now = new Date();

  return (
    <div className="pay-inf">
      <h3 className="sub">{t("sb_ttl_pmt_inf_mpg")}</h3>
      <ul>
        <li className="between-center">
          <h4>{t("txt_total_bk")}</h4>
          <h2 className="sub text-blue-300 ">
            {priceFormat(payInf?.resvAmt ?? 0)}
          </h2>
        </li>
        <li className="">
          <div className="between-center">
            <h5>{t("txt_disc_amt")}</h5>
            <h5>{priceFormat(payInf?.dscAmt ?? 0)}</h5>
          </div>
          <div className="flex justify-between">
            <h5>{t("txt_pym_amnt_cmm")}</h5>
            <h5>{priceFormat(payInf?.payAmt ?? 0)}</h5>
          </div>
          <div className="flex justify-between">
            <h5>{t("txt_unpd_amnt_cmm")}</h5>
            <h5>{priceFormat(payInf?.resvAmt - payInf?.payAmt ?? 0)}</h5>
          </div>
        </li>
        <li className="flex justify-between">
          <h5>{t("lbl_pymnt_mthd_bk")}</h5>
          <h5>{t("txt_card_pay")}</h5>
        </li>
        {pathname.includes("cancel") && (
          <li>
            <div>
              <h4 className="font-fotn-B">{t("txt_cncl_rate_mpg")}</h4>
              <p className="xxs text-red-200">
                {t("txt_cncl_dt_mpg")}&nbsp;:&nbsp;
                {fullDateFormat(now, true, true)}
              </p>
            </div>
            <h2 className="sub text-red-200">
              {priceFormat(payInf?.cnlFeeAmt ?? 0)}
            </h2>
          </li>
        )}
      </ul>
    </div>
  );
}
